import { Loader2 } from "lucide-react";

export function PageHeader({ title, subtitle, icon: Icon, action }) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-gold/20 bg-gold/5">
            <Icon className="h-5 w-5 text-gold" strokeWidth={1.6} />
          </div>
        )}
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-0.5 text-sm text-white/45">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}

export function Scroller({ children }) {
  return <div className="h-full overflow-y-auto"><div className="mx-auto max-w-5xl px-5 py-7 sm:px-8">{children}</div></div>;
}

export function Spinner() {
  return <div className="flex h-full items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-gold" /></div>;
}

export function EmptyState({ icon: Icon, title, hint, children }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-white/10 py-16 text-center">
      {Icon && <Icon className="h-9 w-9 text-white/20" strokeWidth={1.4} />}
      <p className="mt-4 font-heading text-lg text-white/70">{title}</p>
      {hint && <p className="mt-1 max-w-sm text-sm text-white/35">{hint}</p>}
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}

export const goldBtn = "flex items-center gap-2 rounded-xl bg-gradient-to-r from-gold-light to-gold px-4 py-2.5 text-sm font-semibold text-black shadow-gold-sm transition-all hover:shadow-gold";
export const ghostBtn = "flex items-center gap-2 rounded-xl border border-white/10 px-4 py-2.5 text-sm text-white/70 transition-colors hover:border-gold/25 hover:text-white";
